import * as React from 'react'
import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import type { Tab } from 'modules/core/components/Card/types'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import permissionGroups from 'modules/permissions/store/collections/permissionGroups'

export interface PermissionsContainerContext {
  tabs: Tab[]
  loadingPermissionGroups: boolean
}

const userIsAbleToSeeSettings = (user: User) => {
  if (user.employee && !user.employee.hasRegularAccess) return false

  const canAnyPermissions = users.current.policy.can('permissions.permissionsRead')

  const canAnyPermissionGroups =
    users.current.policy.can('permissions.groupCreate') ||
    users.current.policy.can('permissions.groupEdit')

  return canAnyPermissionGroups || canAnyPermissions
}

const PermissionsSettingsContainer = () => {
  const canManagePermissions =
    userIsAbleToSeeSettings(users.current) ||
    users.current.policy.can('apiCore.companyManagePermissions')

  const { loading: loadingPermissionGroups } = useAsyncData(() => {
    return permissionGroups.fetch()
  }, [])

  return (
    <AuthorizeUser authorizeFn={() => canManagePermissions}>
      <Outlet context={{ loadingPermissionGroups }} />
    </AuthorizeUser>
  )
}

export default PermissionsSettingsContainer
